// Hover state for the desktop nav dropdowns (Explore, Tools). One timer is
// shared by every trigger and panel so the pointer can travel between them:
//
// - A menu opens after a short hover, so sweeping across the nav does not
//   flash menus open.
// - Passing over another trigger on the way to an open panel only switches
//   menus if the pointer stays there, so a diagonal path keeps the menu.
// - Leaving starts a grace period that the trigger or panel cancels on
//   re-entry, which covers the gap between the nav and the panel.
//
// Usage: @mouseenter="$store.navMenu.intent('explore')" on a trigger,
// @mouseenter="$store.navMenu.keep()" on its panel, and
// @mouseleave="$store.navMenu.leave()" on both.

const OPEN_DELAY = 120;
const SWITCH_DELAY = 150;
const CLOSE_DELAY = 300;

document.addEventListener("alpine:init", () => {
  window.Alpine.store("navMenu", {
    open: null,
    timer: null,

    intent(menu) {
      clearTimeout(this.timer);
      if (this.open === menu) return;

      this.timer = setTimeout(() => { this.open = menu; }, this.open ? SWITCH_DELAY : OPEN_DELAY);
    },

    keep() {
      clearTimeout(this.timer);
    },

    leave() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => { this.open = null; }, CLOSE_DELAY);
    },

    close() {
      clearTimeout(this.timer);
      this.open = null;
    },
  });
});

document.addEventListener("turbo:visit", () => {
  window.Alpine?.store("navMenu")?.close();
});
